export default {
      id: "ic-close-or-delete-white-usage",
      viewBox: "0 0 30 30",
      url: "/" + "images/icons.3.109.2.svg#ic-close-or-delete-white-usage",
      toString: function () {
        return this.url;
      }
    }